import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../utils/Loader';
import Select from 'react-select';
import { fetchReportRevenue, setReportsFilters } from '../../action';
import PointsSelect from '../utils/PointsSelect';
import DateSelect from '../utils/DateSelect';
import moment from 'moment';
import SortButton from '../utils/SortButton';
import { isEmpty } from 'lodash';
import { formatNumberWithSpaces, parseNumToFixed } from '../../utils/common';
import { fetchFilials, fetchPayments } from '../../action/handbook';
import { roleId } from '../../constants/app';
import { fetchUsersByRole } from '../../action/user';
import { utils, writeFileXLSX } from 'xlsx';
import ErrorContainer from '../utils/ErrorContainer';
import MultiSelect from '../utils/MultiSelect';

const styles = {
    loading: {
        minHeight: '200px',
        display: 'flex',
        justifyContent: 'center'
    }
};

function DetailRow ({item, secondLvl, color='#d5d4ff61', marginLeft = '0px' }) {
    const [ showDetail, setShowDetail ] = useState(false);
    const renderSecond = secondLvl && secondLvl.value !== 'none' && !isEmpty(item.detailData);

    const handleClick = () => {
        if (!renderSecond) return;
        setShowDetail(!showDetail);
    }

    return (
        <>
        <tr onClick={handleClick} className='kt-datatable__row' style={renderSecond ? { cursor: 'pointer', backgroundColor: color } : { backgroundColor: color }}>
            <td className='kt-datatable__cell' style={{ width: '12px' }}>{renderSecond && <i className={`kt-menu__ver-arrow la la-angle-${showDetail ? 'up' : 'down'}`} style={{ fontSize: '0.8rem' }}/>}</td>
            <td className='kt-datatable__cell' style={{ width: 'auto'}}><span style={{ marginLeft: marginLeft }}>{item.name}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(item.count) || 0}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(item.receipt) || 0}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(item.totalSum) || 0}</span></td>
        </tr>
        {renderSecond && showDetail && 
            Object.entries(item.detailData).map(([key, item]) => <DetailRow item={item} color='#bbbaff61' marginLeft={`${parseFloat(marginLeft) + 15}px`} />)
        }
        </>
    )
}

const numDaysWeek = {
    'Понедельник': 1,
    'Вторник': 2,
    'Среда': 3,
    'Четверг': 4,
    'Пятница': 5,
    'Суббота': 6,
    'Воскресенье': 7,
}

function ResultRow ({items}) {
    const result = Object.values(items).reduce((acc, item) => {
        acc.totalSum += item.totalSum || 0;
        acc.count += item.count || 0;
        return acc;
    }, { totalSum: 0, count: 0 });

    const receipt = result.count > 0 ? parseNumToFixed(result.totalSum / result.count) : 0;

    return (
        <tr className='kt-datatable__row' style={{ backgroundColor: '#cfcfcf61'}}>
            <td className='kt-datatable__cell' style={{ width: 'auto'}}><span>ИТОГО</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(result.count) || 0}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(receipt) || 0}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(result.totalSum) || 0}</span></td>
        </tr>
    )
}

function ItemRow ({item, firstLvl, secondLvl}) {
    const [ showDetail, setShowDetail ] = useState(false);
    const renderFirst = firstLvl && firstLvl.value !== 'none' && !isEmpty(item.detailData);
    const renderSecond = !renderFirst && secondLvl && secondLvl.value !== 'none' && !isEmpty(item.detailData);
    const handleClick = () => {
        if (!renderFirst && !renderSecond) return;
        setShowDetail(!showDetail);
    }

    return (
        <>
        <tr onClick={handleClick} className='kt-datatable__row' style={(renderSecond || renderFirst) ? { cursor: 'pointer' } : {}}>
            {(renderSecond || renderFirst) && <td className='kt-datatable__cell' style={{ width: '12px'}}><i className={`kt-menu__ver-arrow la la-angle-${showDetail ? 'up' : 'down'}`} style={{ fontSize: '0.8rem' }}/></td>}
            <td className='kt-datatable__cell' style={{ width: 'auto'}}><span>{item.name}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(item.count) || 0}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(item.receipt) || 0}</span></td>
            <td className='kt-datatable__cell' style={{ width: '140px'}}><span>{formatNumberWithSpaces(item.totalSum) || 0}</span></td>
        </tr>
        {(renderSecond || renderFirst) && showDetail && 
            Object.entries(item.detailData).map(([key, item]) => <DetailRow item={item} secondLvl={renderSecond ? null : secondLvl} marginLeft='45px'/>)
        }
        </>
    )
}

const renderAdress = (item) => {
    if (!item) return 'Не определен';
    return `${item.city.name ? item.city.name : '---'}, ${item.street}, ${item.house}`;
};

const firstLvlOptions = [
    { label: 'Нет', value: 'none' },
    { label: 'Филиалы', value: 'points' },
    { label: 'Дни недели', value: 'daysweek' },
]

export default function SalesHours() {
    const data = useSelector(state => state.reports.salesHours);
    const payments = useSelector(state => state.handbook.payments);
    const points = useSelector(state => state.handbook.filials);
    const pointsCount = useSelector(state => state.handbook.count.filials);
    const pointLoading = useSelector(state => state.loaders.filials);

    const { result, filters, loading } = data;
    const [ regionalDirectors, setRegionalDirectors ] = useState([]);
    const [ _sort, setSort ] = useState({ field: 'name', sort: 'ASC'});
    const [ renderFilters, setRenderFilters ] = useState(filters);

    const dispatch = useDispatch();

    const [ renderDetail, setRenderDetail ] = useState({
        firstLvl: { label: 'Нет', value: 'none' },
        secondLvl: { label: 'Нет', value: 'none' },
    });

    useEffect(() => {
        const getData = async () => {
            const regDirs = await dispatch(fetchUsersByRole({ role: roleId.regionalDirector }));
            const resultDirs = regDirs.map((dir) => ({ value: dir.id, label: dir.name ? dir.name : dir.username, points: dir.points })).sort((a, b) => a.label.localeCompare(b.label, 'ru'));
            setRegionalDirectors(resultDirs);
            if (!pointLoading && (isEmpty(points) || points.length < pointsCount)) await dispatch(fetchFilials(null, true));
        };
        
        if (isEmpty(payments)) dispatch(fetchPayments(true, true));
        getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        return () => {
            dispatch({type: 'RESET_REPORT', name: 'salesHours'});
        }
    }, [dispatch]);

    const handleClickSort = (newFiled) => {
        const { field, sort } = _sort;
        if (newFiled === field) {
            const newSort = sort === 'DESC' ? 'ASC' : 'DESC';
            setSort({field: _sort.field, sort: newSort});
        } else {
            setSort({field: newFiled, sort: 'ASC'});
        }
    }

    const onChangeDateSelect = (e) => {
        if (e && e.min && e.max) {
            const updated = { ...filters};
            updated.created_at_gte = e.min;
            updated.created_at_lte = e.max;
            dispatch(setReportsFilters('salesHours', updated));
        }
    }

    const setDetail = (field) => (data) => {
        const updated = { ...renderDetail }
        if (field === 'firstLvl' && renderDetail.secondLvl.value === data.value) { updated.secondLvl = { label: 'Нет', value: 'none' }}
        updated[field] = data;
        setRenderDetail(updated);
    }

    const setFilters = (field) => (data) => {
        const updated = { ...filters, [field]: data};
        dispatch(setReportsFilters('salesHours', updated));
    }

    const onSearch = () => {
        dispatch(fetchReportRevenue({}, 'salesHours'));
        setRenderFilters(filters);
    }

    const getDetailOptions = (lvl) => {
        switch (lvl) {
            case 'secondLvl': {
                return firstLvlOptions.filter((option) => option.value === 'none' || option.value !== renderDetail.firstLvl.value);
            }
            default: {
                return firstLvlOptions;
            }
        }
    }

    const isDisabledSearch = () => {
        if (loading) return true;
        if ((!filters.points || filters.points.length === 0) && (!filters.regionalDirectors || filters.regionalDirectors.length === 0)) return true;
        return false;        
    }
    
    const onExport = () => {
        const { firstLvl, secondLvl } = renderDetail;
        const data = getGroupedData();
        const isRenderFirst = firstLvl && firstLvl.value !== 'none' && !isEmpty(data);
        const isRenderSecond = secondLvl && secondLvl.value !== 'none' && !isEmpty(data);

        const exportData = Object.entries(data).sort(([aKey, a], [bKey, b]) => {
            const { field, sort } = _sort;
            const aField = a[field || 'name'];
            const bField = b[field || 'name'];
            if (sort === 'DESC') {

                if (field === 'name' && (firstLvl.value === 'daysweek' || (firstLvl.value === 'none' && secondLvl.value === 'daysweek'))) {
                    const aNum = numDaysWeek[aField];
                    const bNum = numDaysWeek[bField];
                    return bNum - aNum; 
                }

                if (typeof aField === 'string') {
                    if(aField.toLowerCase() > bField.toLowerCase()) return -1;
                    if(aField.toLowerCase() < bField.toLowerCase()) return 1;
                    return 0;
                }
                return bField - aField;  
            } else {

                if (field === 'name' && (firstLvl.value === 'daysweek' || (firstLvl.value === 'none' && secondLvl.value === 'daysweek'))) {
                    const aNum = numDaysWeek[aField];
                    const bNum = numDaysWeek[bField];
                    return aNum - bNum; 
                }

                if (typeof aField === 'string') {
                    if(aField.toLowerCase() < bField.toLowerCase()) return -1;
                    if(aField.toLowerCase() > bField.toLowerCase()) return 1;
                    return 0;
                }
                return aField - bField;                                                        
            }
        }).flatMap(([firstKey, firstData]) => {
            if (!isRenderFirst && !isRenderSecond) {
                return {
                    'Часы': firstKey,
                    'Заказы': firstData.count,
                    'Средний чек': firstData.receipt,
                    'Сумма': firstData.totalSum
                };
            }

            if (isRenderFirst && !isRenderSecond) {
                return Object.entries(firstData.detailData).flatMap(([secondKey, secondData]) => {
                    let entity = {};
                    if (firstLvl.value === 'points') {
                        entity = { 'Филиал': firstKey, 'Часы': secondKey };
                    } else {
                        entity = { 'День недели': firstKey, 'Часы': secondKey };
                    }

                    return {
                        ...entity,
                        'Заказы': secondData.count,
                        'Средний чек': secondData.receipt,
                        'Сумма': secondData.totalSum
                    };
                });
            }

            if (!isRenderFirst && isRenderSecond) {
                return Object.entries(firstData.detailData).flatMap(([secondKey, secondData]) => {
                    let entity = {};
                    if (secondLvl.value === 'points') {
                        entity = { 'Филиал': firstKey, 'Часы': secondKey };
                    } else {
                        entity = { 'День недели': firstKey, 'Часы': secondKey };
                    }

                    return {
                        ...entity,
                        'Заказы': secondData.count,
                        'Средний чек': secondData.receipt,
                        'Сумма': secondData.totalSum
                    };
                });
            }

            if (isRenderFirst && isRenderSecond) {
                return Object.entries(firstData.detailData).flatMap(([secondKey, secondData]) => {
                    return Object.entries(secondData.detailData).flatMap(([thridKey, thridData]) => {
                        let entity = {};
                        if (firstLvl.value === 'points') {
                            entity = { 'Филиал': firstKey, 'День недели': secondKey, 'Часы': thridKey };
                        } else {
                            entity = { 'День недели': firstKey, 'Филиал': secondKey, 'Часы': thridKey };
                        }
    
                        return {
                            ...entity,
                            'Заказы': thridData.count,
                            'Средний чек': thridData.receipt,
                            'Сумма': thridData.totalSum
                        };
                    });
                });
            }
        });

        const result = Object.values(data).reduce((acc, item) => {
            acc.totalSum += item.totalSum || 0;
            acc.count += item.count || 0;
            return acc;
        }, { totalSum: 0, count: 0 });
        
        const receipt = result.count > 0 ? parseNumToFixed(result.totalSum / result.count) : 0;

        let keyName = null;

        if (firstLvl && firstLvl.value !== 'none') {
            if (firstLvl.value === 'points') {
                keyName = 'Филиал';
            } else {
                keyName = 'День недели';
            }
        } else if (secondLvl && secondLvl.value !== 'none') {
            if (secondLvl.value === 'points') {
                keyName = 'Филиал';
            } else {
                keyName = 'День недели';
            }
        } else {
            keyName = 'Часы';
        }
        
        exportData.push({
            [keyName]: 'ИТОГО',
            'Заказы': result.count,
            'Средний чек': receipt,
            'Сумма': result.totalSum
        });

        const ws = utils.json_to_sheet(exportData);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, 'Продажи по часам ');
        const detailText = [];
        const periodText = `${moment(renderFilters.created_at_gte).format('DD.MM.YYYY')} - ${moment(renderFilters.created_at_lte).format('DD.MM.YYYY')}`;
        detailText.push(periodText);
        if (isRenderFirst) detailText.push(`Детализация 1 - ${firstLvl.label || '-'}`);
        if (isRenderSecond) detailText.push(`Детализация 2 - ${secondLvl.label || '-'}`);
        const resultText = detailText.join(', ');
        writeFileXLSX(wb, `Отчет продажи по часам ${resultText}.xlsx`);
    }

    const renderHead = () => {
        return(
            <div className="kt-portlet__head" style={{ flexDirection: 'column', gap: '10px' }}>
                <div className="kt-portlet__head-label">
                    <h3 className="kt-portlet__head-title">
                        Продажи по часам
                    </h3>
                </div>
                <div className='kt-separator kt-separator--border-dashed kt-separator--space-sm'/>
                <div><h6 style={{ color: 'black'}}> Поиск </h6></div>
                <div className="kt-portlet__head-toolbar" style={{ flexWrap: 'wrap', gap: '10px' }}>
                    <div style={{ width: 200 }}>
                        <label>Период *</label>
                        <DateSelect 
                        isDisabled={loading}
                        isLoading={loading}
                        optionsDate={{
                            tommorow: true,
                            period: true,
                            prevWeek: true,
                            prevMonth: true,
                        }}
                        limit={{ 
                            field: 'months',
                            value: 6
                        }}
                        width={200}
                        onChange={onChangeDateSelect}
                        />
                    </div>
                    <div>
                        <label>Филиалы {(filters.regionalDirectors && filters.regionalDirectors.length > 0) ? '' : '*'}</label>
                        <PointsSelect width={200} placeholder='Филиалы' values={filters.points} setData={setFilters('points')} disabled={loading || (filters.regionalDirectors && filters.regionalDirectors.length > 0)}/>
                    </div>
                    <div style={{ width: 200 }}>
                        <label>Региональный директор {(filters.points && filters.points.length > 0) ? '' : '*'}</label>
                        <MultiSelect data={regionalDirectors} width={200} placeholder='Рег. директор' values={filters.regionalDirectors} setData={setFilters('regionalDirectors')} loading={loading} disabled={loading || (filters.points && filters.points.length > 0)}/>
                    </div>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <button disabled={isDisabledSearch()} onClick={onSearch} style={{ marginTop: '1.9rem' }} className="btn btn-primary">Найти</button>
                        {renderData() && <button disabled={loading} onClick={onExport} style={{ marginTop: '1.9rem' }} className='btn btn-dark btn-icon-sm'>Экспорт</button>}
                    </div>
                </div>
                <div className='kt-separator kt-separator--border-dashed kt-separator--space-sm'/>
                <div><h6 style={{ color: 'black'}}> Детализация </h6></div>
                <div className="kt-portlet__head-toolbar" style={{ flexWrap: 'wrap', gap: '10px' }}>
                    <div style={{ width: 200 }}>
                        <label>Уровень 1</label>
                        <Select
                            closeMenuOnSelect={true}
                            options={getDetailOptions('firstLvl')}
                            onChange={setDetail('firstLvl')}
                            placeholder="Уровень 1"
                            noOptionsMessage={() => 'Нет'}
                            value={renderDetail.firstLvl}                   
                        />
                    </div>
                    <div style={{ width: 200 }}>
                        <label>Уровень 2</label>
                        <Select
                            closeMenuOnSelect={true}
                            options={getDetailOptions('secondLvl')}
                            onChange={setDetail('secondLvl')}
                            placeholder="Уровень 2"
                            noOptionsMessage={() => 'Нет'}
                            value={renderDetail.secondLvl}                   
                        />
                    </div>
                </div>
            </div>
        );
    }


    const getGroupedData = () => {
        const { firstLvl, secondLvl } = renderDetail;

        const hoursKeys = [
            '00:00 - 01:00', '01:00 - 02:00', '02:00 - 03:00', '03:00 - 04:00', '04:00 - 05:00', '05:00 - 06:00',
            '06:00 - 07:00', '07:00 - 08:00', '08:00 - 09:00', '09:00 - 10:00', '10:00 - 11:00', '11:00 - 12:00',
            '12:00 - 13:00', '13:00 - 14:00', '14:00 - 15:00', '15:00 - 16:00', '16:00 - 17:00', '17:00 - 18:00',
            '18:00 - 19:00', '19:00 - 20:00', '20:00 - 21:00', '21:00 - 22:00', '22:00 - 23:00', '23:00 - 00:00',
        ];

        const getKeys = (lvl) => {
            if (lvl.value === 'none') return [];
            const keys = new Set();

            if (lvl.value === 'points') {
                if (renderFilters.points && renderFilters.points.length > 0) {
                    renderFilters.points.forEach(point => {
                        const dataPoint = points.find((p) => parseInt(p.id) === parseInt(point.value));
                        if (dataPoint) return keys.add(renderAdress(dataPoint));
                    });
                } else if (renderFilters.regionalDirectors && renderFilters.regionalDirectors.length > 0) {
                    renderFilters.regionalDirectors.forEach((dir) => {
                        if (dir && dir.points && dir.points.length > 0) dir.points.forEach((point) => {
                            if (point) {
                                let pointId = point.id ? point.id : point;
                                const dataPoint = points.find((point) => point.id === pointId);
                                return keys.add(renderAdress(dataPoint));
                            }
                            keys.add('Филиал не задан');
                        });
                    })
                } else {
                    result.forEach((order) => {
                        if (order && order.point) return keys.add(renderAdress(order.point));
                        keys.add('Филиал не задан');
                    });
                }
            } else {
                return ['Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота', 'Воскресенье']
            }
            
            return Array.from(keys);
        }
    
        const createData = () => {
            const firstKeys = getKeys(firstLvl);
            const secondKeys = getKeys(secondLvl)
            
            const data = {};
            
            
            if (firstLvl.value !== 'none') {
                firstKeys.forEach(firstKey => {
                    const firstData = {
                        name: firstKey,
                        totalSum: 0,
                        plan: 0,
                        planPersent: 0,
                        count: 0,
                        receipt: 0,
                        detailData: {}
                    };

                    if (secondLvl.value !== 'none') {
                        secondKeys.forEach((secondKey) => {
                            const secondData = {
                                name: secondKey,
                                totalSum: 0,
                                count: 0,
                                receipt: 0,
                                detailData: {}
                            }

                            hoursKeys.forEach((hourKey) => {
                                const hourData = {
                                    name: hourKey,
                                    totalSum: 0,
                                    count: 0,
                                    receipt: 0,
                                    detailData: {}
                                }
                                secondData.detailData[hourKey] = hourData;
                            });

                            firstData.detailData[secondKey] = secondData;
                        });
                    } else {
                        hoursKeys.forEach((hourKey) => {
                            const hourData = {
                                name: hourKey,
                                totalSum: 0,
                                count: 0,
                                receipt: 0,
                                detailData: {}
                            }
                            firstData.detailData[hourKey] = hourData;
                        });
                    }
                
                data[firstKey] = firstData;
                });
            } else if (secondLvl.value !== 'none') {
                secondKeys.forEach((secondKey) => {
                    const secondData = {
                        name: secondKey,
                        totalSum: 0,
                        count: 0,
                        receipt: 0,
                        detailData: {}
                    }

                    hoursKeys.forEach((hourKey) => {
                        const hourData = {
                            name: hourKey,
                            totalSum: 0,
                            count: 0,
                            receipt: 0,
                            detailData: {}
                        }
                        secondData.detailData[hourKey] = hourData;
                    });

                    data[secondKey] = secondData;
                });
            } else {
                hoursKeys.forEach((hourKey) => {
                    const hourData = {
                        name: hourKey,
                        totalSum: 0,
                        count: 0,
                        receipt: 0,
                        detailData: {}
                    }
                    data[hourKey] = hourData;
                });
            }
            
            return data;
        };

        const getKeyByLevel = (order, levelType) => {
            if (levelType === 'hour') {
                const time = parseInt(order.timeZone, 10) || 3;
                const baseOrderDate = order.visible_datetime || order.created_at;
                const orderDate = moment.utc(baseOrderDate).add(time, 'hours');
                const hour = moment(orderDate).format('HH:mm');
                const key = hoursKeys.find((hours) => {
                    const [ gte, lt ] = hours.split(' - ');
                    if (lt === '00:00') {
                        if (hour >= gte) {
                            if (hour <= '23:59') return true;
                            return false;
                        }
                        return false;
                    }
                    if (hour >= gte && hour < lt) return true;
                    return false;
                });
                return key || 'Не определено';
            } else if (levelType === 'points') {
                return order.point ? renderAdress(order.point) : 'Филиал не задан';
            } else {
                const time = parseInt(order.timeZone, 10) || 3;
                const baseOrderDate = order.visible_datetime || order.created_at;
                const orderDate = moment.utc(baseOrderDate).add(time, 'hours');
                const day = moment(orderDate).day();
                let dayIndex = day === 0 ? 6 : day - 1;
                const weekDays = ['Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота', 'Воскресенье'];
                return weekDays[dayIndex] || 'Не определен';
            }
        };

        const calculateReceiptForAllLevels = (detailData) => {
            Object.keys(detailData).forEach(key => {
                const item = detailData[key];
                
                if (item.count > 0) item.receipt = parseNumToFixed(item.totalSum / item.count);
                if (item.detailData && Object.keys(item.detailData).length > 0) calculateReceiptForAllLevels(item.detailData);
            });
            return detailData;
        };
    
        const fillNullData = (data) => {
            const updated = JSON.parse(JSON.stringify(data));
            
            (result || []).forEach((order) => {
                const totalPrice = parseFloat(order.totalPrice) || 0;

                const hourKey = getKeyByLevel(order, 'hour');
                const firstKey = firstLvl.value !== 'none' ? getKeyByLevel(order, firstLvl.value) : null;
                const secondKey = secondLvl.value !== 'none' ? getKeyByLevel(order, secondLvl.value) : null;
                
                if (firstKey && updated[firstKey]) {
                    updated[firstKey].totalSum = parseNumToFixed((parseFloat(updated[firstKey].totalSum) || 0) + totalPrice);
                    updated[firstKey].count += 1;
                    
                    if (secondKey && updated[firstKey].detailData[secondKey]) {
                        const secondData = updated[firstKey].detailData[secondKey];
                        secondData.totalSum = parseNumToFixed((parseFloat(secondData.totalSum) || 0) + totalPrice);
                        secondData.count += 1;
                        const hourData = secondData.detailData[hourKey] || {};
                        hourData.totalSum = parseNumToFixed((parseFloat(hourData.totalSum) || 0) + totalPrice);
                        hourData.count += 1;
                    } else {
                        const hourData = updated[firstKey].detailData[hourKey] || {};
                        hourData.totalSum = parseNumToFixed((parseFloat(hourData.totalSum) || 0) + totalPrice);
                        hourData.count += 1;
                    }
                } else if (secondKey) {
                    const secondData = updated[secondKey];
                    secondData.totalSum = parseNumToFixed((parseFloat(secondData.totalSum) || 0) + totalPrice);
                    secondData.count += 1;
                    const hourData = secondData.detailData[hourKey] || {};
                    hourData.totalSum = parseNumToFixed((parseFloat(hourData.totalSum) || 0) + totalPrice);
                    hourData.count += 1;
                } else {
                    updated[hourKey].totalSum = parseNumToFixed((parseFloat(updated[hourKey].totalSum) || 0) + totalPrice);
                    updated[hourKey].count += 1; 
                }
            });
            
            return calculateReceiptForAllLevels(updated);
        };
    
        const data = createData();
        const filledData = fillNullData(data);

        return filledData;
    };

    const renderTable = () => {
        const { field, sort } = _sort;
        const { firstLvl, secondLvl } = renderDetail;
        const data = getGroupedData();

        return(
            <div className='kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded'>
                <table className='kt-datatable__table' style={{ width: '100%'}}>
                    <thead className='kt-datatable__head' style={{ position: 'sticky' }}>
                        <tr className='kt-datatable__row'>
                            <th className='kt-datatable__cell' style={{ width: 'auto' }}>
                                <SortButton 
                                className={field === 'name' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                text='Наименование' onClick={() => handleClickSort('name')} 
                                up={field === 'name' && sort === 'ASC'}
                                />
                            </th>
                            <th className='kt-datatable__cell' style={{ width: '140px' }}>
                                <SortButton 
                                className={field === 'count' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                text='Заказы' 
                                onClick={() => handleClickSort('count')} 
                                up={field === 'count' && sort === 'ASC'}
                                />
                            </th>
                            <th className='kt-datatable__cell' style={{ width: '140px' }}>
                                <SortButton 
                                className={field === 'receipt' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                text='Ср. чек' 
                                onClick={() => handleClickSort('receipt')} 
                                up={field === 'receipt' && sort === 'ASC'}
                                />
                            </th>
                            <th className='kt-datatable__cell' style={{ width: '140px' }}>
                            <SortButton 
                                className={field === 'totalSum' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                text='Сумма' 
                                onClick={() => handleClickSort('totalSum')} 
                                up={field === 'totalSum' && sort === 'ASC'}
                                />
                            </th>
                        </tr>
                    </thead>
                    <tbody className='kt-datatable__body'>
                        {Object.entries(data)
                        .sort(([aKey, a], [bKey, b]) => {
                            const { field, sort } = _sort;
                            const aField = a[field || 'name'];
                            const bField = b[field || 'name'];
                            if (sort === 'DESC') {

                                if (field === 'name' && (firstLvl.value === 'daysweek' || (firstLvl.value === 'none' && secondLvl.value === 'daysweek'))) {
                                    const aNum = numDaysWeek[aField];
                                    const bNum = numDaysWeek[bField];
                                    return bNum - aNum; 
                                }

                                if (typeof aField === 'string') {
                                    if(aField.toLowerCase() > bField.toLowerCase()) return -1;
                                    if(aField.toLowerCase() < bField.toLowerCase()) return 1;
                                    return 0;
                                }
                                return bField - aField;  
                            } else {

                                if (field === 'name' && (firstLvl.value === 'daysweek' || (firstLvl.value === 'none' && secondLvl.value === 'daysweek'))) {
                                    const aNum = numDaysWeek[aField];
                                    const bNum = numDaysWeek[bField];
                                    return aNum - bNum; 
                                }

                                if (typeof aField === 'string') {
                                    if(aField.toLowerCase() < bField.toLowerCase()) return -1;
                                    if(aField.toLowerCase() > bField.toLowerCase()) return 1;
                                    return 0;
                                }
                                return aField - bField;                                                        
                            }
                        })
                        .map(([key, item]) => <ItemRow item={item} firstLvl={firstLvl} secondLvl={secondLvl}/>)}
                        <ResultRow items={data}/>
                    </tbody>
                </table>
            </div>
        );
    }

    const renderData = () => {
        if ((!result || result.length === 0) && (!renderFilters.points || renderFilters.points.length === 0) && (!renderFilters.regionalDirectors || renderFilters.regionalDirectors.length === 0)) return false;
        return true;       
    }

    const renderBody = () => {
        if (loading || pointLoading) return <div style={styles.loading}><Loader /></div>;

        if (!renderData()) return <div className='kt-portlet'> 
            <div className='kt-portlet__body'>Нет данных</div> 
        </div>

        return(
        <div className="kt-portlet">
            <ErrorContainer field="salesHours" style={{ margin: '20px 20px 0px 20px' }} hasCloseButton={true}/>
            <div className='kt-portlet__body'>
            {renderTable()}    
            </div> 
        </div>
        );
    }

    return (
        <>
            <div className="kt-portlet">
                {renderHead()}
            </div>
            {renderBody()}
        </>         
    );
}